import * as React from 'react';

interface ErrorMessageTypes {
	message?: string;
	extraClass?: string;
}

const ErrorMessage: React.FC<ErrorMessageTypes> = ({ message, extraClass }) => {
	return (
		<p className={`error-notification ${extraClass ? extraClass : null}`}>
			{message ? message : <>Oops, there is something wrong. Please come back later!</>}
		</p>
	);
};

export default ErrorMessage;
